export const environment = {
  WS_GRAPHQL_ENDPOINT: 'ws://api.np.re-engage.gym-app.de/graphql',
  HTTP_GRAPHQL_ENDPOINT: 'https://api.np.re-engage.gym-app.de/graphql',
  AUTH0_GRAPHQL_AUDIENCE: 'urn:re-engage:graphql-api',
  AUTH0_DOMAIN: 'gym-app-np.eu.auth0.com',
  AUTH0_CLIENT_ID: 'BffpkHk3wKC0LJJPVeEGZT2xgBDFids2',
  STAGE: 'np',
  HOST: 'manage.np.re-engage.gym-app.de',
  ASSET_URL:
    'https://re-engage-assets-np.s3.eu-central-1.amazonaws.com/re-engage-management-portal/public/assets',
};
